module.exports = __webpack_public_path__ + "static/react-e1eb58566a28676adf3ee7419956aef1.png";